<template>
    <div v-if="isLoading" class="loading-overlay"><p>Acessando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>
    

    <div class="solicitacao-layout">
        <div class="solicitacao-info">
            <div class="form-edit-page">
                <div class="row row-space">
                    <div class="form-item-char05">
                        <label class="label-caption">Número</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdregistro) }}</div>
                    </div>

                    <div class="form-item-data">
                        <label class="label-caption">Data</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtregistro) }}</div>
                    </div>

                    <div class="form-item-char15">
                        <label class="label-caption">Protocolo</label>
                        <div class="field-label">{{ objView.protocolo }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Categoria</label>
                        <div class="field-label">{{ objView.titulo }}</div>
                    </div>

                    <div class="form-item-char30">
                        <label class="label-caption">Coordenadas</label>
                        <div class="field-label field-label-center">{{ objView.latitude }} x {{ objView.longitude }}</div>
                    </div>

                    <div class="form-item-char20">
                        <label class="label-caption">Situação</label>
                        <div class="field-label field-label-center">{{ objView.nmstatus }}</div>
                    </div>
                </div>



                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Nome</label>
                        <div class="field-label">{{ objView.nmpessoa }}</div>
                    </div>
                    
                    <div class="form-item-char20">
                        <label class="label-caption">Fone</label>
                        <div class="field-label field-label-center">{{ objView.fone }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Descrição/Detalhamento</label>
                        <div class="field-label">{{ objView.descricao }}</div>
                    </div>            
                </div>


                <div class="row-end">
                    <button v-if="ckAutorizacao && !objView.nmlogradouro" type="button" @click="setarEndereco">Ler Endereço</button>
                    <button v-if="ckAutorizacao" type="button" class="btn-confirm" @click="gerarOS">Gerar OS</button>
                    <button v-if="ckAutorizacao" type="button" class="btn-cancel" @click="showModalJustificativa=true">Reprovar</button>
                    <button type="button" @click="closeForm">Retornar</button>
                </div>
            </div>

            <div v-if="showMap && !showModalImage" class="map-card">
                <MapComponent :latitude="objView.latitude" :longitude="objView.longitude" />
            </div>
        </div>


        
        <div v-if="imageSrc" class="solicitacao-foto">
            <div class="form-edit-page foto-card">
                <img :src="imageSrc" alt="Imagem carregada" @click="showModalImage = true" />
            </div>
        </div>
    </div>

    
    <div>
        <ImageModal v-if="showModalImage" :imageSrc="imageSrc" :visible="showModalImage" @close="showModalImage=false" />
    </div>
    

    <div>
        <ModalJustificativa
            :visible="showModalJustificativa"
            @update:visible="(value) => (showModalJustificativa = value)"
            @submit="anularSolicitacao" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import ImageModal from '@/components/modals/ImageModal.vue';
import MapComponent from '@/components/MapComponent.vue';
import ModalJustificativa from '@/components/modals/ModalJustificativa.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({
    idView: {type: Number, default: 0},
    ckAutorizacao: {type: Boolean, default: false}});

const ckEmitSave = ref(false);
const imageSrc = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objView = ref({});
const showMap = ref(false);
const showModalImage = ref(false);
const showModalJustificativa = ref(false);


const anularSolicitacao = async({justificativa}) => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await Api.genericPut('/cad/ipos_solicitacao', {
            id: objView.value.id, 
            lganulacao: globalStore.idlogin, 
            obanulacao: justificativa});
        if (r.bolok==1){
            emit('close');
            emit('save');
        }else{msgAlerta.value=r.erro}
    }catch (error){msgAlerta.value=error;
    }finally{isLoading.value=false;}
}


const closeForm = () => {if (ckEmitSave.value){emit('save')} emit('close')}


const gerarOS = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await Api.genericPost('/ip/ipossolicitacoes/gera_os', {id: objView.value.id, idusuario: globalStore.idusuario});
        if (r.bolok==1){
            emit('close');
            emit('save');
        }else{msgAlerta.value=r.erro}
    }catch (error){msgAlerta.value=error;
    }finally{isLoading.value=false;}
}


const lerDados = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/dados/manif_registro', {
            idmunicipio: globalStore.idmunicipio,
            id: props.idView,
        });
        Object.assign(objView.value, req[0]);
        showMap.value = ((objView.value) && (objView.value.latitude) && (objView.value.longitude));

        // LISTA DE ANEXOS  --  MOSTRANDO APENAS O PRIMEIRO
        const lsImagens = await Api.genericPost('/dados/manif_registro/anexos', {
            idmunicipio: globalStore.idmunicipio,
            id: objView.value.id});
        if (lsImagens.length > 0){
            const rUrl = await Api.genericPost('/main/solicitar/download', {id: lsImagens[0].idanexo});
            if (rUrl.bolok === 1){
                imageSrc.value = rUrl.download_url;
            }
        }
    }catch (error){msgAlerta.value=error;
    }finally{isLoading.value = false;}
}


const setarEndereco = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/ip/ipossolicitacoes/processar/coordenadas', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        if (req.bolok==1){
            ckEmitSave.value=true;
            await lerDados();
        }else{msgAlerta.value=req.erro}
    }catch (error){msgAlerta.value=error;
    }finally{isLoading.value = false;}
}


onMounted(lerDados);
</script>

<style scoped>
.solicitacao-layout {
    display: grid;
    grid-template-columns: minmax(520px, 1fr) minmax(280px, 360px);
    gap: 14px;
    align-items: start;
}

.solicitacao-foto {
    min-width: 0;
}

.foto-card {
    padding: 8px;
}

.solicitacao-foto img {
    width: 100%;
    height: calc(100vh - 220px);
    min-height: 420px;
    object-fit: contain;
    border-radius: 8px;
    cursor: pointer;
    background: #f8fafc;
}

.solicitacao-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
}

.map-card {
    border: 1px solid #d8dee9;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    min-height: 320px;
}

.map-card :deep(.leaflet-container),
.map-card :deep(.map-container),
.map-card :deep(#map) {
    width: 100%;
    height: 320px;
}

@media (max-width: 1100px) {
    .solicitacao-layout {
        grid-template-columns: 1fr;
    }

    .solicitacao-info {
        order: 1;
    }

    .solicitacao-foto {
        order: 2;
    }

    .solicitacao-foto img {
        height: auto;
        min-height: unset;
        max-height: 520px;
    }
}
</style>